export default __webpack_public_path__ + "static/N0092-7a8aaeea0411d700bb0edc427adbbc87.png";